export default __webpack_public_path__ + "static/media/GateModule.fe79b9a6.png";